export default __webpack_public_path__ + "static/media/Love.687f2193.png";